import React, { FC } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import {
  logOutAction,
  clearLogOutAction,
} from '../../../../redux/actions/login';
import useRedirect from '../../../../hooks/useRedirect';
import { UiRoutes } from '../../../../lib/constants';
import { getProfileImgText } from '../../../../lib/helper';
import { listConstants } from './profile.constants';
import Props from './typing';
import ThemedActionIcon from 'components/ThemedActionIcon';
import './style.scss';

const ProfileMenu: FC<Props> = (props): JSX.Element => {
  const { push } = useRedirect();
  const handleClickLogOut = () => {
    if (props?.logOutAction) {
      props?.logOutAction();
    }
  };

  const handleClickUserManagement = () => {
    if (props?.loginState?.isAdmin && props?.loginState?.MerchantId === 0) {
      push(UiRoutes.ADMIN_USER_MANAGEMENT);
      props.clearMerchantInfoAction && props.clearMerchantInfoAction();
    } else {
      props.handleClickUserManagement && props.handleClickUserManagement();
    }
  };


  return (
    <React.Fragment>
      <div className='profile-menu-box'>
        <div className='user-detail-profile'>
          <div className='sort-name'>
            {props?.loginState?.UserFullName
              ? getProfileImgText(props.loginState.UserFullName)
              : 'N/A'}
          </div>
          <div className='user-des'>
            <h6>{props?.loginState?.UserFullName ?? 'NA'}</h6>
            <p>{props?.loginState?.UserEmail ?? 'NA'}</p>
            <label>
              Last successful log in on{' '}
              {props?.loginState?.lastLoggedIn
                ? format(
                    new Date(props.loginState.lastLoggedIn),
                    'd MMM hh:mm aa'
                  )
                : 'NA'}
            </label>
            <label>
              {props?.loginState?.failedLoginTime &&
                `Last failed log in attempt on ${format(
                  new Date(props.loginState.failedLoginTime),
                  'd MMM hh:mm aa'
                )}`}
            </label>
          </div>
        </div>
        <ul>
          {listConstants({
            handleClickChangePassword: props.handleClickChangePassword
              ? props.handleClickChangePassword
              : () => {},
            handleClickLogOut,
            handleClickUserManagement,
          }).map((item, index) => (
            <li
              key={index}
              style={{ cursor: 'pointer' }}
              onClick={item.onClick}
            >
              <a>
                <ThemedActionIcon
                  name={item.iconName}
                  className='profile-menu-icon'
                  standalone
                />{' '}
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
});

export default connect(mapStateToProps, {
  logOutAction,
  clearLogOutAction,
})(ProfileMenu);
